import React from 'react';

const Ico3 = (props) => {
    return (

            <svg width="249" height="291" viewBox="0 0 249 291" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M97.0546 262.763C97.0546 277.934 109.329 290.208 124.5 290.208C139.671 290.208 151.945 277.934 151.945 262.763H97.0546ZM219.387 204.976V124.708C219.387 79.8854 188.355 42.3721 146.429 32.4421V22.5121C146.429 10.3754 136.637 0.583313 124.5 0.583313C112.363 0.583313 102.571 10.3754 102.571 22.5121V32.4421C60.6446 42.3721 29.6133 79.8854 29.6133 124.708V204.976L0.375 234.214V248.833H248.625V234.214L219.387 204.976ZM179.667 152.43H138.292V193.805H110.708V152.43H69.3333V124.708H110.708V83.3333H138.292V124.708H179.667V152.43Z" fill="url(#paint0_radial)"/>
                <defs>
                    <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(124.5 130.543) rotate(89.8612) scale(206.457 176.963)">
                        <stop stopColor="#00F0FF"/>
                        <stop offset="1" stopColor="#1022C0" stopOpacity="0"/>
                    </radialGradient>
                </defs>
            </svg>


    );
};

export default Ico3;